import LandingPage from "./LandingPage";

function IndexPage() {
  return <LandingPage />;
}

export default IndexPage;
